/**
 * @generated SignedSource<<23ee512b4f217680e446ccb35cee2742>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateOrEditActionItemGroupEditMutation$variables = {
  groupId: string;
  newName: string;
};
export type CreateOrEditActionItemGroupEditMutation$data = {
  readonly editCustomActionItemGroup: {
    readonly editedGroup: {
      readonly id: string;
      readonly name: string;
    } | null;
  } | null;
};
export type CreateOrEditActionItemGroupEditMutation = {
  response: CreateOrEditActionItemGroupEditMutation$data;
  variables: CreateOrEditActionItemGroupEditMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "groupId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "newName"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "groupId",
        "variableName": "groupId"
      },
      {
        "kind": "Variable",
        "name": "newName",
        "variableName": "newName"
      }
    ],
    "concreteType": "EditCustomActionItemGroup",
    "kind": "LinkedField",
    "name": "editCustomActionItemGroup",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ActionItemGroupNode",
        "kind": "LinkedField",
        "name": "editedGroup",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateOrEditActionItemGroupEditMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateOrEditActionItemGroupEditMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "68209265ca703f5b97129353178ba710",
    "id": null,
    "metadata": {},
    "name": "CreateOrEditActionItemGroupEditMutation",
    "operationKind": "mutation",
    "text": "mutation CreateOrEditActionItemGroupEditMutation(\n  $groupId: ID!\n  $newName: String!\n) {\n  editCustomActionItemGroup(groupId: $groupId, newName: $newName) {\n    editedGroup {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2cc21066a4c5d94745ec1a8ed5b36c48";

export default node;
